import Dexie from 'dexie';

const db = new Dexie("newCatsDatabase2");
db.version(1).stores({ cats_tree: "plat,value" });
export { db };
